import {styled} from '@mui/material/styles'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import IconButton from '@mui/material/IconButton'
import DoDisturbOnIcon from '@mui/icons-material/DoDisturbOn'
import WarningOutlinedIcon from '@mui/icons-material/WarningOutlined'

export const StyledTitleWarningIcon = styled(DoDisturbOnIcon)(({theme}) => ({
  color: theme.palette.hpAccentRedLight,
  fontSize: theme.typography.h5.fontSize
}))

export const StyledFooterWarningIcon = styled(WarningOutlinedIcon)(({theme}) => ({
  color: theme.palette.hpAccentRed,
  fontSize: theme.typography.titleMedium.fontSize
}))

export const StyledWarningFooter = styled('div')(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
  fontSize: theme.typography.subtitle3.fontSize,
  color: theme.palette.grey[600]
}))

export const StyledDivCenter = styled('div', {
  shouldForwardProp: (prop) => prop !== 'textBold'
})(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  fontSize: theme.typography.subtitle1.fontSize,
  fontWeight: theme.typography.fontWeightRegular,
  padding: '4px 0'
}))

export const StyledTitleRow = styled('span')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px'
}))

export const StyledUserNameBold = styled('div')(({theme}) => ({
  fontWeight: theme.typography.fontWeightBold,
  fontSize: theme.typography.body1.fontSize,
  padding: '4px 0'
}))

export const StyledButtonGroup = styled('span')(({theme}) => ({
  display: 'flex',
  gap: theme.spacing(2)
}))

export const StyledUserDetail = styled('div')(({theme}) => ({
  textAlign: 'left',
  padding: '4px 0',
  fontSize: theme.typography.subtitle1.fontSize,
  fontWeight: theme.typography.fontWeightRegular,
  color: theme.palette.hpBlack
}))

export const StyledDivFooter = styled('div')(({theme}) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: theme.spacing(2),
  paddingTop: theme.spacing(8)
}))

export const StyledDialog = styled(Dialog)(() => ({
  '& .MuiPaper-root': {
    minWidth: '420px',
    borderRadius: '8px'
  }
}))

export const StyledDeleteButton = styled(Button)(({theme}) => ({
  backgroundColor: theme.palette.hpAccentRedLight,
  color: theme.palette.hpWhite,
  width: 'auto',
  minWidth: '100px',
  padding: '8px 24px',
  borderRadius: '4px',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: theme.palette.hpAccentRed
  }
}))

export const StyledDialogTitle = styled(DialogTitle)(({theme}) => ({
  fontSize: theme.spacing(2.25),
  fontWeight: theme.typography.fontWeightBold,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(2, 3)
}))

export const StyledDialogContent = styled(DialogContent)(({theme}) => ({
  padding: theme.spacing(3, 5, 4, 5)
}))

export const StyledIconButton = styled(IconButton)(({theme}) => ({
  color: theme.palette.hpBase
}))

export const CancelRemoveUserButton = styled(Button)(({theme}) => ({
  backgroundColor: theme.palette.hpWhite,
  color: theme.palette.hpPrimaryDark,
  textTransform: 'none',
  padding: '8px 24px',
  minWidth: '100px',
  fontSize: theme.typography.body1.fontSize,
  '&:hover': {
    backgroundColor: theme.palette.hpWhite,
    textDecoration: 'underline'
  }
}))
